import React from 'react';
import './IndexCard.css';

const IndexCard = ({ title, sections, onCardClick, size='', shadow=false }) => {
  return (
    <div className={`index-card ${size} ${shadow&&'shadow'} bg-white
     hover:border         transition-all
        duration-500
        ease-in-out
        hover:translate-x-2
        hover:-translate-y-2`}>
      <div className="card-title" onClick={onCardClick}>
          {title}
      </div>
      <div className="red-line" />
      {sections.map((section, index) => (
        <div key={index} className="section">
          {section}
        </div>
      ))}
    </div>
  );
};

export default IndexCard;
